export default "__VITE_ASSET__b6bfeeca__"